/* eslint-disable @typescript-eslint/naming-convention */
import * as React from 'react';
import { Divider, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';

import { User } from '../lib/PlannerDTOs';
import { fetchAllUsers } from '../store/state/users/actions';
import { AppDispatch, AppState } from '../store/types';
import { ControlledInputPropsBase } from './InputControlProps';

const { Option } = Select;

interface OwnProps extends ControlledInputPropsBase<string> {
  query: string;
  onSearch: (value: string) => void;
}

interface StateProps {
  owners: User[];
  isFetching: boolean;
  total: number;
}

interface DispatchProps {
  fetchOwners: (query: string) => void;
}

type InnerComponentProps = OwnProps & StateProps & DispatchProps;

class InnerComponent extends React.Component<InnerComponentProps> {
  componentDidUpdate(prevProps) {
    const { query: prevQuery } = prevProps;
    const { fetchOwners, query: currentQuery } = this.props;
    if (prevQuery !== currentQuery) {
      return fetchOwners(currentQuery);
    }
  }

  renderDropdown = (menu) => {
    const { query, owners } = this.props;
    const ownersLength = owners.length > 0 ? owners.length : 0;
    return (
      <div>
        {
          <React.Fragment>
            <div
              style={{
                marginLeft: '12px',
                marginTop: '5px',
                fontStyle: 'italic',
              }}
            >
              {`${
                query.length >= 0 ? 'Keep' : 'Start'
              } typing to see more relevant suggestions...`}
            </div>
            <Divider style={{ margin: '4px 0' }} />
          </React.Fragment>
        }
        {menu}
        {ownersLength >= 0 && (
          <React.Fragment>
            <Divider style={{ margin: '4px 0' }} />
            <div
              style={{
                marginLeft: '12px',
                marginBottom: '5px',
                fontSize: '15px',
                fontWeight: 'bold',
              }}
            >{`Showing Top ${owners.length} Matches`}</div>
          </React.Fragment>
        )}
      </div>
    );
  };

  renderOptions = (owners: User[]) => {
    return owners && owners.length > 0 ? (
      owners.map((v: User) => <Option key={v.Id}>{v.Email}</Option>)
    ) : (
      <Option key="no-user" disabled>
        No users found
      </Option>
    );
  };

  render() {
    const { isFetching, owners, onSearch, onChange, description, title } =
      this.props;

    return (
      <>
        <h4>{title}</h4>
        <Select
          showSearch
          value={this.props.value}
          allowClear={true}
          filterOption={false}
          onSearch={onSearch}
          onChange={onChange}
          placeholder={description}
          style={{ width: '100%' }}
          disabled={false}
          dropdownRender={this.renderDropdown}
          defaultActiveFirstOption={true}
        >
          {isFetching ? (
            <span style={{ pointerEvents: 'none' }}>
              <Spin size="small" /> Loading...
            </span>
          ) : (
            this.renderOptions(owners)
          )}
        </Select>
      </>
    );
  }
}
function returnStateInstead(values): StateProps {
  return {
    owners: values,
    isFetching: false,
    total: values.length,
  };
}

function mapStateToProps(state: AppState): StateProps {
  const { users, isFetchingUsers } = state.users!;
  if (isFetchingUsers) {
    return {
      owners: [],
      isFetching: true,
      total: 0,
    };
  }
  if (!users) {
    return {
      owners: [],
      isFetching: false,
      total: 0,
    };
  }
  const values = users ? Object.values(users) : [];
  return returnStateInstead(values);
}

function mapDispatchToProps(dispatch: AppDispatch): DispatchProps {
  return { fetchOwners: (query: string) => dispatch(fetchAllUsers(query)) };
}

const ConnectedInnerComponent = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  AppState
>(
  mapStateToProps,
  mapDispatchToProps,
)(InnerComponent);

type OwnersAutoCompleteProps = ControlledInputPropsBase<string>;

interface OwnersAutoCompleteState {
  query: string;
}

export class OwnersAutoComplete extends React.Component<
  OwnersAutoCompleteProps,
  OwnersAutoCompleteState
> {
  state = { query: '' };
  constructor(props: OwnersAutoCompleteProps) {
    super(props);
    this.handleSearch = debounce(this.handleSearch, 500);
  }
  handleSearch = (value: string) => {
    this.setState({ query: value });
  };
  handleChange = (_value: string, data) => {
    const child = data && data.props.children;
    if (!child) {
      this.setState({ query: '' });
      return this.props.onChange('');
    }
    this.props.onChange(child);
  };
  render() {
    const { query } = this.state;
    const props = {
      ...this.props,
      query,
      onSearch: this.handleSearch,
      onChange: this.handleChange,
    };
    return <ConnectedInnerComponent {...props} />;
  }
}
